import { Divider, Typography } from "antd";
import React, { useState } from "react";
import { syncFormasDePago } from "../../services/formaDePagoSyncService";
import FormaDePagoList from "./FormaDePagoList";
import "./FormaDePagoStyles.css";

const { Title } = Typography;

const FormaDePagoManagement = () => {
    const isMobile = window.innerWidth < 768;
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [syncing, setSyncing] = useState(false);

    const handleSync = async () => {
        setSyncing(true);
        try {
            const success = await syncFormasDePago();
            if (success) {
                window.messageApi.success("Formas de pago sincronizadas correctamente");
                setRefreshTrigger(prev => prev + 1);
            } else {
                window.messageApi.error("Error al sincronizar formas de pago");
            }
        } catch (error) {
            window.messageApi.error("Error al sincronizar: " + error.message);
        } finally {
            setSyncing(false);
        }
    };

    return (
        <div className="formaDePago-management-container">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Title level={2}>{isMobile ? "Formas de Pago" : "Gestión de Formas de Pago"}</Title>
            </div>
            <Divider />

            <FormaDePagoList
                refreshTrigger={refreshTrigger}
                onSync={handleSync}
                syncing={syncing}
            />
        </div>
    );
};

export default FormaDePagoManagement; 